import ListProcesses from "@/views/packing_house/quality_control/process/ListProcesses.vue";
import ListHarvestedBatches from "@/views/packing_house/quality_control/process/ListHarvestedBatches.vue";
import ListTemplates from "@/views/packing_house/quality_control/process/ListTemplates.vue";
import ListInspects from "@/views/packing_house/quality_control/process/ListInspects.vue";
import NewInspect from "@/views/packing_house/quality_control/process/NewInspect.vue";
import EditInspect from "@/views/packing_house/quality_control/process/EditInspect.vue";
import ShowInspect from "@/views/packing_house/quality_control/process/ShowInspect.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ph",
  role: "quality_control",
  permission: "process",
});

export default [
  {
    path: "/ph/quality_control/process/list_processes/:packing_house_id",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/quality_control/process/:packing_house_process_id/list_harvested_batches",
    name: routeName("list_harvested_batches"),
    component: ListHarvestedBatches,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/quality_control/process/:packing_house_process_id/list_templates/:harvested_batch_id",
    name: routeName("list_templates"),
    component: ListTemplates,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/quality_control/process/:packing_house_process_id/list_inspects/:harvested_batch_id/:packing_process_quality_template_id",
    name: routeName("list_inspects"),
    component: ListInspects,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/quality_control/process/:packing_house_process_id/new_inspect/:harvested_batch_id/:packing_process_quality_template_id/",
    name: routeName("new_inspect"),
    component: NewInspect,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/quality_control/process/:packing_house_process_id/edit_inspect/:harvested_batch_id/:packing_process_quality_template_id/:quality_inspect_id",
    name: routeName("edit_inspect"),
    component: EditInspect,
    props: true,
    meta: META
  },
  {
    path: "/ph/:packing_house_id/quality_control/process/:packing_house_process_id/show_inspect/:harvested_batch_id/:packing_process_quality_template_id/:quality_inspect_id",
    name: routeName("show_inspect"),
    component: ShowInspect,
    props: true,
    meta: META
  }
]
